// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3XBNe","modalForm":"UpgradeEpcsModal_modalForm__3_BbO","modalFooter":"UpgradeEpcsModal_modalFooter__3EzZa"};